import { render } from "./collections-page.vue?vue&type=template&id=7a750af1&scoped=true"
import script from "./collections-page.vue?vue&type=script&lang=js"
export * from "./collections-page.vue?vue&type=script&lang=js"

import "./collections-page.vue?vue&type=style&index=0&id=7a750af1&scoped=true&lang=css"

import exportComponent from "/var/www/tap-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a750af1"]])

export default __exports__